/* Product Authentication — 단발 인증 (PRD-HK-LAUNCH-V3 D13)
 * 디자인 언어: PoC 아티팩트 ffd7fcab (상태별 컬러 결과 카드·CS 칩·스피너) 계승.
 * 배포 후 VERIFY_API 를 ax-web 프록시 베이스 URL 로 교체 (Cloud Run 직접 URL 아님 —
 * 사설 배포라 브라우저 직접 호출 불가, P6-PROXY-PLAN-2026-07-20.md 참조).
 * 입력 화면 영어 고정 — 결과 카드는 서버 반환 언어(title/body) 그대로 렌더.
 */
(function () {
  'use strict';

  var VERIFY_API = 'https://overseas-auth-proxy.vercel.app/api/product-auth';
  var HOW_TO_USE_URL = 'https://www.youtube.com/watch?v=OPsVJFu8Kyo';

  var form = document.getElementById('pv-form');
  var formSection = document.getElementById('pv-form-section');
  var formError = document.getElementById('pv-form-error');
  var snInput = document.getElementById('pv-sn');
  var countrySel = document.getElementById('pv-country');
  var submitBtn = document.getElementById('pv-submit');
  var result = document.getElementById('pv-result');
  var rCard = document.getElementById('pv-result-card');
  var rIcon = document.getElementById('pv-result-icon');
  var rTitle = document.getElementById('pv-result-title');
  var rBody = document.getElementById('pv-result-body');
  var rMeta = document.getElementById('pv-result-meta');
  var rCs = document.getElementById('pv-cs');
  var rHowto = document.getElementById('pv-howto');
  var againBtn = document.getElementById('pv-again');

  // DOM 가드 — 필수 요소 누락 시 조용히 중단 (silent 실패 방지, PRD §6)
  if (!form || !snInput || !countrySel || !result || !rCard || !rTitle || !rBody) {
    if (window.console) console.error('[verify] required DOM missing');
    return;
  }

  var SN_RE = /^[A-Z0-9-]{5,50}$/;

  // 상태 → 아이콘·카드 컬러 변형 (vp- 언어: 정품=그린, 안내=블루, 주의=오렌지, 오류=레드)
  var STATE = {
    valid:               { icon: '✅', variant: 'valid' },
    already_verified:    { icon: 'ℹ️', variant: 'info' },
    kr_serial:           { icon: 'ℹ️', variant: 'info' },
    not_found:           { icon: '⚠️', variant: 'warn' },
    invalid_format:      { icon: '⚠️', variant: 'warn' },
    rate_limited:        { icon: '⏳', variant: 'warn' },
    service_unavailable: { icon: '❌', variant: 'error' },
    error:               { icon: '❌', variant: 'error' }
  };

  function normalize(v) {
    return (v || '').replace(/\s+/g, '').toUpperCase();
  }

  function showResult(data) {
    var res = data && data.result ? data.result : 'error';
    var st = STATE[res] || STATE.error;

    rCard.className = 'pv-result pv-r-' + st.variant;
    rIcon.textContent = st.icon;
    rTitle.textContent = (data && data.title) || 'Something went wrong';
    rBody.textContent = (data && data.body) ||
      'We could not process your request. Please try again later.';

    // 메타: S/N(모노) + 제품명 — 서버가 준 값만 표시
    rMeta.innerHTML = '';
    if (data && data.sn) {
      var snLine = document.createElement('div');
      snLine.appendChild(document.createTextNode('S/N: '));
      var snEl = document.createElement('strong');
      snEl.textContent = data.sn;
      snLine.appendChild(snEl);
      rMeta.appendChild(snLine);
    }
    if (data && data.product) {
      var pLine = document.createElement('div');
      pLine.textContent = data.product;
      rMeta.appendChild(pLine);
    }

    // CS 칩 — 서버가 cs_email 을 준 상태에서만 (mailto, 라벨=이메일 자체라 언어중립)
    if (data && data.cs_email) {
      rCs.textContent = '✉ ' + data.cs_email;
      rCs.href = 'mailto:' + data.cs_email;
      rCs.hidden = false;
    } else {
      rCs.hidden = true;
    }

    var showHowto = res === 'valid' || res === 'already_verified';
    rHowto.hidden = !showHowto;
    if (showHowto) rHowto.href = HOW_TO_USE_URL;

    formSection.hidden = true;
    result.hidden = false;
    window.scrollTo(0, 0);
  }

  function setLoading(on) {
    submitBtn.disabled = on;
    if (on) {
      submitBtn.innerHTML = '<span class="pv-spinner" aria-hidden="true"></span>Verifying…';
    } else {
      submitBtn.textContent = 'Verify';
    }
  }

  againBtn.addEventListener('click', function () {
    result.hidden = true;
    formSection.hidden = false;
    formError.textContent = '';
    snInput.value = '';
    snInput.focus();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    formError.textContent = '';

    var country = countrySel.value;
    var sn = normalize(snInput.value);
    if (!country) {
      formError.textContent = 'Please select your country of purchase.';
      return;
    }
    if (!SN_RE.test(sn)) {
      formError.textContent = 'Please check the serial number (letters and digits only).';
      return;
    }
    snInput.value = sn;

    setLoading(true);

    var url = VERIFY_API + '/verify?sn=' + encodeURIComponent(sn) +
      '&country=' + encodeURIComponent(country);
    var timer = setTimeout(function () { showResult(null); }, 15000);

    fetch(url, { mode: 'cors' })
      .then(function (r) { return r.json(); })
      .then(function (data) { clearTimeout(timer); showResult(data); })
      .catch(function () { clearTimeout(timer); showResult(null); })
      .then(function () { setLoading(false); });
  });
})();
